/** @format */

import { GET_REFUNDABLE_ORDERS, INITIATE_REFUND, REJECT_REFUND, GET_REFUND_REQUESTS } from "./refund.type";

const initialState = {
	refundableOrders: [],
	refundRequests: [],
	total: 0,
};

const refundReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_REFUNDABLE_ORDERS:
			return {
				...state,
				refundableOrders: action.payload.data,
				total: action.payload.total,
			};
		case GET_REFUND_REQUESTS:
			return {
				...state,
				refundRequests: action.payload.data,
				total: action.payload.total,
			};
		case INITIATE_REFUND:
			return {
				...state,
				refundableOrders: state.refundableOrders.filter((order) => order._id !== action.payload),
			};
		case REJECT_REFUND:
			return {
				...state,
				refundableOrders: state.refundableOrders.filter((order) => order._id !== action.payload),
			};
		default:
			return state;
	}
};

export default refundReducer;
